export default __webpack_public_path__ + "static/media/laptop.3db09583.png";